/**
 *  路由权限相关管理
 * */
import router from "@/router";
import store from "@/store";
import config from "@/config";
import NProgress from "nprogress"; // 进度条
import "nprogress/nprogress.css"; // 进度条样式
import {
  authorityComparison,
  Cookie,
  getLocalStorage,
  Storage,
} from "@src/_common/utils/mUtils";

router.beforeEach((to, from, next) => {
  if (to.meta.code) {
    switch (to.meta.code) {
      case "zhibiao": {
        document.title = to.meta.title;
        break;
      }
      case "nianbao": {
        document.title = "以奋斗敬未来";
        NProgress.start(); // 结束Progress
        break;
      }
      default: {
        to.meta.title = "员工跟投系统";
        NProgress.done(); // 结束Progress
      }
    }
  }

  let userData = { oauth: {}, permissionsList: [] };
  // 如果工程配置loginType是local的话则刷新页面从本地取登陆信息，保持登陆状态
  if (
    process.env.VUE_APP_ENV_NAME === "development" ||
    config.loginType === "local"
  ) {
    userData = getLocalStorage("user") || { oauth: {}, permissionsList: [] };
    store.commit('UPDATE_USER_FROM_LOCAL')
  } else {
    userData = store.state.user;
  }

  if (
    (to.query.ticket ||
      to.query.token ||
      to.query.gys ||
      to.query.rh ||
      to.query.wxToken ||
      to.query.ygtj ||
      to.query.notLogin) &&
    to.path !== "/author"
  ) {
    // 纪录上次进入地址前先清除ticket 和 token 防止进入死循环
    Cookie.set(
      "beforeLoginUrl",
      encodeURIComponent(
        createURL(to.path, {
          ...to.query,
          ticket: "",
          token: "",
          wxToken: "",
          gys: "",
          rh: "",
          ygtj: "",
          jdgj: "",
          notLogin: "",
        })
      ),
      1 / 24 / 60,
      window.location.host,
      window.location.pathname.substring(0, window.location.pathname.length - 1)
    );
    Storage.set(
      "beforeLoginUrl",
      encodeURIComponent(
        createURL(to.path, {
          ...to.query,
          ticket: "",
          token: "",
          wxToken: "",
          gys: "",
          rh: "",
          ygtj: "",
          jdgj: "",
          notLogin: "",
        })
      ),
      1 / 24 / 60,
      window.location.host,
      window.location.pathname.substring(0, window.location.pathname.length - 1)
    );
    next({
      path: "/author",
      query: to.query,
      replace: true,
    });
    return false;
  }
  if (!userData.oauth.access_token && !to.meta.noNeedLogin) {
    Cookie.set(
      "beforeLoginUrl",
      encodeURIComponent(to.fullPath),
      1 / 24 / 60,
      window.location.host,
      window.location.pathname.substring(0, window.location.pathname.length - 1)
    ); // 保存用户进入的url
    Storage.set(
      "beforeLoginUrl",
      encodeURIComponent(
        createURL(to.path, { ...to.query, ticket: "", token: "" })
      ),
      1 / 24 / 60,
      window.location.host,
      window.location.pathname.substring(0, window.location.pathname.length - 1)
    );
    // 跳转到登录
    store.dispatch("goLogin");
    return false;
  }
  // 权限判断
  // let permissionList = userData.permissionsList || [];
  // let routerPermissionList = [];
  // for (let i = 0, len = to.matched.length; i < len; i++) {
  //   if (Array.isArray(to.matched[i].meta.promissonCode)) {
  //     routerPermissionList = [
  //       ...routerPermissionList,
  //       ...to.matched[i].meta.promissonCode,
  //     ];
  //   } else {
  //     routerPermissionList.push(to.matched[i].meta.promissonCode);
  //   }
  // }
  // 判断当前登录角色是否有即将进入的路由权限
  // if (
  //   to.meta.trust ||
  //   !to.meta.promissonCode ||
  //   authorityComparison(permissionList, routerPermissionList)
  // ) {
    next();
  // } else {
  //   /*  store.dispatch('showMassage', {type: 'fail', message: '抱歉，您没有进入该模块的权限!'})*/
  //   next("/no-permision");
  //   return false;
  // }

  //TODO 根据加载的资源，更新路由meta属性中的title属性，所有的页面title使用route.meta.title
  next();
});

router.afterEach((to) => {
  if (to.meta.code) {
    switch (to.meta.code) {
      case "zhibiao": {
        document.title = to.meta.title;
        break;
      }
      case "nianbao": {
        document.title = "以奋斗敬未来";

        NProgress.done(); // 结束Progress
        break;
      }
      default: {
        document.title = to.meta.title || "员工跟投系统";
        NProgress.done(); // 结束Progress
      }
    }
  }

  //  指挥指标查看更多与城市项目跳转时修改title的方法
  if (to.meta.code === "updateTitle") {
    document.title = to.query.title;
  }
});

function createURL(url, param) {
  var urlLink = "";
  for (let key in param) {
    let link = "&" + key + "=" + param[key];
    urlLink += link;
  }
  urlLink = url + "?" + urlLink.substr(1);
  return urlLink;
}
